import { render, staticRenderFns } from "./DetailHealthArticle.vue?vue&type=template&id=7b3f6e88&"
import script from "./DetailHealthArticle.vue?vue&type=script&lang=js&"
export * from "./DetailHealthArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports